import { Exception } from 'exception/Exception';
import { TrendModel } from 'api/dto/Trend.dto';

export const STORE_NAME = 'trend';

export namespace TrendState {
  export type Domain = {
    list: TrendModel[];
    errors: Exception[] | null;
  };

  export const INITIAL_DOMAIN: Domain = {
    list: [],
    errors: null,
  };
}
